import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { SmallUnitReviewrDecision, Languages, ServiceStatus, FormMode } from 'src/app/shared/models/enums.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { EntranceRequestComponent } from 'src/app/front-user/services/small-units/entrance-request/entrance-request.component';
import { SmallUnitsAdminService } from '../shared/services/small-units.service.admin';
import { SmallUnitadminDTO } from '../shared/models/small-units-admin.model';
import { SmallUnitsServiceFE } from 'src/app/front-user/services/small-units/shared/services/small-units.service';

@Component({
  selector: 'app-review-request',
  templateUrl: './review-request-component.html'
})


export class SmallUnitsReviewRequestComponent implements OnInit {
  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest//= new BaseRequest();
  decision = SmallUnitReviewrDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  decisionValue: number;
  smallunitsReviewerForm: FormGroup;
  user: User = new User();
  agent: User = new User();
  adminDecisionObject: SmallUnitadminDTO = new SmallUnitadminDTO();
  showRequest = false;
  agentId: string;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  isLoaded: boolean = false;
  isErrorMessage: boolean = false;

  @ViewChild('EntranceRequest',{static: false}) EntranceRequest: EntranceRequestComponent;
  responseObj: ResponseObject = new ResponseObject();
  lockTaskErrorMessage: boolean = false;

  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private translate: TranslateService,
    private SmallUnitServ: SmallUnitsServiceFE,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private SmallUnitAdminServ: SmallUnitsAdminService, private agentSrv: AgentService) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    //this.baseRequestId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }

    this.user = this.globalSrv.user;

  }

  ngOnInit() {

    this.buildForm(null);
    // history.state.data.requestId = "";
  }

  buildForm(decision) {
    this.smallunitsReviewerForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });
    if (decision == SmallUnitReviewrDecision.MoreInformation) {
      this.smallunitsReviewerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
      });

    }
  }
  changeDecision(value) {
    this.buildForm(value);
    this.smallunitsReviewerForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
  }

  get f() {
    return this.smallunitsReviewerForm.controls;
  }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        this.agentId = this.baseRequestDTO.RequestorId;
        this.isLoaded = true;

        // if (this.requestStatus == ServiceStatus.PendingonMeasurementsOfficerReviewerApproval) {
        //   this.formMode = FormMode.Add;
        //   this.smallunitsReviewerForm.enable();

        // }
        // else
        if (history.state.data && history.state.data.isCompleted) {
          this.getSmallUnitRequest();
          this.formMode = FormMode.Readonly;
          this.smallunitsReviewerForm.disable();
        }
        // else {
        //   this.getFeesEstimation();
        //   this.formMode = FormMode.Readonly;
        //   this.smallunitsReviewerForm.disable();
        // }
      }
    )
  }

  getSmallUnitRequest() {

    this.SmallUnitServ.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          if (this.responseObj.Data['SmallUnitReviewActionId'] == SmallUnitReviewrDecision.MoreInformation) {
            this.decisionValue = SmallUnitReviewrDecision.MoreInformation;
            this.buildForm(this.decisionValue);
            this.smallunitsReviewerForm.patchValue({
              Decision: SmallUnitReviewrDecision.MoreInformation,
              MoreInformation: this.responseObj.Data['SmallUnitMoreInformation']
            });
          }
          else {
            this.decisionValue = SmallUnitReviewrDecision.Approve;
            this.smallunitsReviewerForm.patchValue({
              Decision: SmallUnitReviewrDecision.Approve,
            });
          }

        }
      }

    );
  }
  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.smallunitsReviewerForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    // this.adminDecisionObject = this.smallunitsReviewerForm.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.Id = this.baseRequestId;
    this.adminDecisionObject.SmallUnitReviewActionId = this.smallunitsReviewerForm.controls.Decision.value;
    if (this.adminDecisionObject.SmallUnitReviewActionId == SmallUnitReviewrDecision.MoreInformation) {
      this.adminDecisionObject.SmallUnitMoreInformation = this.smallunitsReviewerForm.controls.MoreInformation.value;
    }

    this.SmallUnitAdminServ.AddReviewerDecision(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.smallunitsReviewerForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.'+data.ErrorMessages[0]), false);

            this.loading = false;
          }

        });
  }
}
